export default __webpack_public_path__ + "static/media/arrow-down.26102f91.svg";